import { createFileRoute } from '@tanstack/react-router';

import {
  InsertionOrder,
  InsertionOrderSearchParamsSchema,
} from '@/features/trafficking';

export const Route = createFileRoute('/_app/trafficking/insertion-order')({
  validateSearch: InsertionOrderSearchParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <InsertionOrder />;
}
